module.exports = __webpack_public_path__ + "static/img/b1ac28ad3cd09e687953f544935f3bfe.21b8361.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/b1ac28ad3cd09e687953f544935f3bfe.jpg
// module id = V7pB
// module chunks = 4